import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./ViewApplication.css";
import { changeLang } from "../../componets/Language/ChangeLang";

export default function ({ header, village }) {
	const Header = (name) => (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">
				<b>{name}</b>
			</h5>
		</div>
	);

	function View() {
		const data = [
			{
				col1: `${changeLang.get("national_delimitation.district")}:`,
				col2: `${village?.districtCode}-${village?.district}`,
				col3: `${changeLang.get("national_delimitation.constituency")}:`,
				col4: `${village?.constituencyCode}-${village?.constituency}`
			},
			{
				col1: `${changeLang.get("national_delimitation.electoralDivision")}:`,
				col2: `${village?.pollingDivisionCode}-${village?.pollingDivision}`,
				col3: `${changeLang.get("national_delimitation.votingCentre")}:`,
				col4: `${village?.registrationCentreCode}`
			},
			{
				col1: `${changeLang.get("national_delimitation.village")}:`,
				col2: `${village?.code}-${village?.name}`,
				col3: "",
				col4: ""
			}
		];

		return (
			<DataTable
				className="remove-border"
				header={Header(header)}
				size="small"
				scrollable={true}
				value={data}
				dataKey="id"
				responsiveLayout="scroll"
				style={{ width: "100%" }}
			>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
										<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
										<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
										<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
			</DataTable>
		);
	}

	return (
		<>
			<View />
		</>
	);
}
